import { render } from "./zlByCollection.vue?vue&type=template&id=1dedd358&scoped=true&xmlns=http%3A%2F%2Fwww.w3.org%2F1999%2Fhtml"
import script from "./zlByCollection.vue?vue&type=script&lang=js"
export * from "./zlByCollection.vue?vue&type=script&lang=js"

import "./zlByCollection.vue?vue&type=style&index=0&id=1dedd358&scoped=true&lang=css"

import exportComponent from "/home/LiuJing/code/MyProjects/YiZhiWang/yizhiwang_web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1dedd358"]])

export default __exports__